import { useRef, useState } from "react";
import { Logo } from "../graphics/logos";
import { Link } from "wouter";

export const Menu = () => {
  const toggle = useRef();
  const [clicked, isClicked] = useState(false);

  function handleClick() {
    isClicked(!clicked);
    toggle && toggle.current.classList.toggle("open");
  }
  return (
    <menu>
      <Link to="/">
        <Logo />
      </Link>
      <h2>installation | digital | light</h2>

      <button className="menu-button-container" onClick={handleClick}>
        <div className="menu-button"></div>
      </button>
      <ul className="menu" ref={toggle}>
        <li>
          <Link onClick={handleClick} to="/enquiries">
            Enquiries & purchases
          </Link>
        </li>
        <li>
          <a onClick={handleClick} href="/#artist">
            meet the artist
          </a>
        </li>
        <li>
          <a onClick={handleClick} href="/#news">
            news
          </a>
        </li>
      </ul>
    </menu>
  );
};
